import { render, staticRenderFns } from "./PreferenceAccount.vue?vue&type=template&id=54065dae&"
import script from "./PreferenceAccount.vue?vue&type=script&lang=ts&"
export * from "./PreferenceAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54065dae')) {
      api.createRecord('54065dae', component.options)
    } else {
      api.reload('54065dae', component.options)
    }
    module.hot.accept("./PreferenceAccount.vue?vue&type=template&id=54065dae&", function () {
      api.rerender('54065dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceAccount.vue"
export default component.exports